
<div class="">
    <h1 class="es-h1 mt-4">
        Create an Account
    </h1>
    <p [innerHtml]="headerText"></p>
    
</div>
